import { Container, Service } from 'typedi';

import { type IApiError, toApiError } from '../services/apiError';
import { AUTH } from '../services/types';
import { SessionStore } from '../stores/SessionStore';

const describeError = (error: unknown) =>
  error instanceof Error ? error.message : (JSON.stringify(error) ?? String(error));

@Service()
export class SessionController {
  private readonly _store = Container.get(SessionStore);
  private readonly _auth = Container.get(AUTH);

  check = async (): Promise<void> => {
    try {
      const session = await this._auth.check();
      this._store.setState(session ? { status: 'signedIn', roles: session.roles } : { status: 'anonymous' });
    } catch (error) {
      this._store.setState({ status: 'anonymous', error: describeError(error) });
    }
  };

  login = (): void => this._auth.login();

  retry = (): void => {
    this._store.setState({ status: 'checking' });
    this._auth.retry();
    void this.check();
  };

  inFrame = (): boolean => this._auth.inFrame();

  /** Back to the login screen, with an optional reason. */
  signOut = (error?: string): void => this._store.setState({ status: 'anonymous', error });

  /** Maps an API failure; an Unauthenticated one signs out and yields null. */
  reportError = (error: unknown): IApiError | null => {
    const apiError = toApiError(error);
    if (apiError.kind !== 'unauthenticated') return apiError;
    this.signOut(apiError.message);
    return null;
  };
}
